module.exports = __webpack_public_path__ + "media/recipes/19-c0fccfa1.png";